import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import HomeScreen from './pages/home-screen';
import VendorDetailModal from './pages/vendor-detail-modal';
import ServiceListingScreen from './pages/service-listing-screen';
import Bookings from 'pages/Bookings';
import Profile from 'pages/Profile';

const Routes = () => {
    return (
        <BrowserRouter>
            <ErrorBoundary>
                <ScrollToTop />
                <RouterRoutes>
                    {/* Define your route here */}
                    <Route path="/" element={<HomeScreen />} />
                    <Route path="/home-screen" element={<HomeScreen />} />
                    <Route path="/vendor-detail-modal" element={<VendorDetailModal />} />
                    <Route path="/service-listing-screen" element={<ServiceListingScreen />} />
                    <Route path="/bookings" element={<Bookings />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="*" element={<NotFound />} />
                </RouterRoutes>
            </ErrorBoundary>
        </BrowserRouter>
    );
};

export default Routes;
